import { css } from 'lit'
import { csColorAction, csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style = css`
  :host {
    display: block;
    box-sizing: border-box;
  }

  .zone-settings-note {
    --cse-text-color: ${csColorText.muted};
  }
  .zone-settings-fields,
  .area-padding-fields,
  .area-gap-fields,
  .area-alignment-fields,
  .image-settings-fields {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
    padding: ${csSpacing.spacing05} ${csSpacing.spacing06};
  }
  .zone-panel-empty {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing06};
    padding: ${csSpacing.spacing06};
    color: var(--cse-color-text-secondary, #6c757d);
  }
  .selection-legend {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .selection-legend-item {
    display: flex;
    align-items: center;
    gap: ${csSpacing.spacing05};
  }
  .selection-legend-item strong {
    font-weight: 600;
  }
  .selection-legend-swatch {
    flex: none;
    width: 14px;
    height: 14px;
    box-sizing: border-box;
    border-radius: 2px;
    border: 2px dashed;
  }
  .selection-legend-swatch-area {
    border-color: ${csColorFunctional.highlight};
  }
  .selection-legend-swatch-zone {
    border-color: ${csColorFunctional.success};
  }
  .selection-legend-swatch-widget {
    border-color: ${csColorAction.linkPrimary};
  }
  .area-padding-stack,
  .area-gap-stack {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
  }
`
